import React, { createContext, useContext, useState, useEffect } from 'react';

const AppContext = createContext();

const DEMO_USERS = [
  { id: 1, name: 'Admin User', email: 'admin@marketingscapers.com', password: 'admin123', role: 'Super Admin', image: null }
];

const INITIAL_SERVICES = [
  { id: 1, name: 'SEO Optimization', content: 'Comprehensive SEO strategies to boost your search rankings and drive organic traffic to your business website.', image: null, createdAt: new Date('2024-01-10T09:30:00').toISOString(), updatedAt: new Date('2024-03-15T14:20:00').toISOString() },
  { id: 2, name: 'Social Media Marketing', content: 'End-to-end social media management including content creation, scheduling, and analytics for all major platforms.', image: null, createdAt: new Date('2024-01-20T11:00:00').toISOString(), updatedAt: new Date('2024-04-01T10:00:00').toISOString() },
  { id: 3, name: 'PPC Advertising', content: 'Data-driven pay-per-click campaigns on Google, Meta, and LinkedIn to maximize ROI and lead generation.', image: null, createdAt: new Date('2024-02-05T08:15:00').toISOString(), updatedAt: new Date('2024-04-10T16:30:00').toISOString() },
  { id: 4, name: 'Content Marketing', content: 'Strategic content creation and distribution to establish authority, build trust, and convert prospects into customers.', image: null, createdAt: new Date('2024-02-18T13:45:00').toISOString(), updatedAt: new Date('2024-04-12T09:00:00').toISOString() },
];

const INITIAL_ENQUIRIES = [
  { id: 1, name: 'Ravi Kumar', email: 'ravi.kumar@example.com', subject: 'SEO Services Inquiry', message: 'Hello, I am interested in your SEO optimization services for my e-commerce website. Could you please provide a detailed proposal with pricing?', status: 'pending', createdAt: new Date('2024-04-10T10:30:00').toISOString() },
  { id: 2, name: 'Priya Sharma', email: 'priya.sharma@techcorp.in', subject: 'Social Media Management', message: 'We are looking for a reliable agency to manage our social media presence across Instagram, LinkedIn, and Twitter. Please share your service packages.', status: 'completed', createdAt: new Date('2024-04-12T14:00:00').toISOString() },
  { id: 3, name: 'Arun Mehta', email: 'arun@startupindia.com', subject: 'PPC Campaign Setup', message: 'We want to launch a Google Ads campaign for our new product launch. Budget is around 50,000 INR/month. Can you help?', status: 'pending', createdAt: new Date('2024-04-15T09:15:00').toISOString() },
  { id: 4, name: 'Sneha Patel', email: 'sneha.p@bizgrowth.com', subject: 'Complete Digital Marketing', message: 'Looking for a full-service digital marketing agency for our retail brand. We need SEO, social media, and email marketing support.', status: 'pending', createdAt: new Date('2024-04-18T16:45:00').toISOString() },
  { id: 5, name: 'Vikram Nair', email: 'vikram.nair@nairco.in', subject: 'Content Strategy', message: 'Interested in your content marketing services. We want to build a strong blog presence and newsletter for our B2B software company.', status: 'completed', createdAt: new Date('2024-04-20T11:30:00').toISOString() },
];

const INITIAL_TESTIMONIALS = [
  { id: 1, name: 'Karthik Rajan', role: 'CEO', company: 'Rajan Enterprises', rating: 5, review: 'MarketingScapers transformed our digital presence completely. Our leads tripled within just three months. Highly recommend their services!', status: 'approved', createdAt: new Date('2024-04-10T09:00:00').toISOString() },
  { id: 2, name: 'Priya Sharma', role: 'Marketing Head', company: 'TechCorp India', rating: 4, review: 'Excellent social media management. They really understand our brand voice and deliver consistent results across all platforms.', status: 'pending', createdAt: new Date('2024-04-18T11:30:00').toISOString() },
  { id: 3, name: 'Suresh Anand', role: 'Founder', company: 'Anand Tech Solutions', rating: 5, review: 'Their PPC campaigns have been phenomenal. We saw a 200% ROI in the first quarter. The team is incredibly responsive and data-driven.', status: 'approved', createdAt: new Date('2024-04-22T14:00:00').toISOString() },
  { id: 4, name: 'Meena Krishnan', role: 'Director', company: 'Sri Siddhi Exports', rating: 4, review: 'Great experience working with MarketingScapers for our international SEO needs. They delivered above expectations and on schedule.', status: 'pending', createdAt: new Date('2024-05-01T10:15:00').toISOString() },
  { id: 5, name: 'Lakshmi Devi', role: 'Owner', company: 'Devi Jewels', rating: 5, review: 'Our Instagram following grew by 10,000 in just two months! The content they create is beautiful and perfectly aligned with our brand.', status: 'pending', createdAt: new Date('2024-05-05T08:45:00').toISOString() },
];

const INITIAL_DEMOS = [
  { id: 1, name: 'Karthik Rajan', email: 'karthik@rajan.in', phone: '9876543210', company: 'Rajan Enterprises', notes: 'Interested in full-stack digital marketing. Has a budget of 1L/month. Very enthusiastic about results-based pricing.', demoDate: '2024-04-22', demoTime: '11:00', status: 'pending', createdAt: new Date('2024-04-19T08:00:00').toISOString() },
  { id: 2, name: 'Meena Krishnan', email: 'meena.k@srisiddhi.com', phone: '8765432109', company: 'Sri Siddhi Exports', notes: 'Export company looking for international SEO and LinkedIn marketing. Asked for ROI-based case studies.', demoDate: '2024-04-23', demoTime: '14:30', status: 'completed', createdAt: new Date('2024-04-19T10:00:00').toISOString() },
  { id: 3, name: 'Suresh Anand', email: 'suresh@anandtech.io', phone: '7654321098', company: 'Anand Tech Solutions', notes: 'Tech startup, needs aggressive growth marketing. Wants weekly reports and dedicated account manager.', demoDate: '2024-04-25', demoTime: '10:00', status: 'pending', createdAt: new Date('2024-04-20T09:30:00').toISOString() },
  { id: 4, name: 'Lakshmi Devi', email: 'lakshmi@devijewels.com', phone: '6543210987', company: 'Devi Jewels', notes: 'Traditional jewellery brand wanting to go digital. Instagram and Google Shopping ads are priority.', demoDate: '2024-04-26', demoTime: '15:00', status: 'pending', createdAt: new Date('2024-04-21T12:00:00').toISOString() },
];

export function AppProvider({ children }) {
  const [theme, setTheme] = useState(() => localStorage.getItem('ms_theme') || 'light');
  // Auth lives in sessionStorage so it is NOT shared across tabs.
  // Opening a new tab or pasting the URL in a fresh tab starts unauthenticated.
  const [currentUser, setCurrentUser] = useState(() => {
    const saved = sessionStorage.getItem('ms_user');
    return saved ? JSON.parse(saved) : null;
  });
  const [users, setUsers] = useState(() => {
    const saved = localStorage.getItem('ms_users');
    return saved ? JSON.parse(saved) : DEMO_USERS;
  });
  const [services, setServices] = useState(() => {
    const saved = localStorage.getItem('ms_services');
    return saved ? JSON.parse(saved) : INITIAL_SERVICES;
  });
  const [enquiries, setEnquiries] = useState(() => {
    const saved = localStorage.getItem('ms_enquiries');
    return saved ? JSON.parse(saved) : INITIAL_ENQUIRIES;
  });
  const [demos, setDemos] = useState(() => {
    const saved = localStorage.getItem('ms_demos');
    return saved ? JSON.parse(saved) : INITIAL_DEMOS;
  });
  const [testimonials, setTestimonials] = useState(() => {
    const saved = localStorage.getItem('ms_testimonials');
    return saved ? JSON.parse(saved) : INITIAL_TESTIMONIALS;
  });
  const [alert, setAlert] = useState(null);

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme);
    localStorage.setItem('ms_theme', theme);
  }, [theme]);

  useEffect(() => { localStorage.setItem('ms_users', JSON.stringify(users)); }, [users]);
  useEffect(() => { localStorage.setItem('ms_services', JSON.stringify(services)); }, [services]);
  useEffect(() => { localStorage.setItem('ms_enquiries', JSON.stringify(enquiries)); }, [enquiries]);
  useEffect(() => { localStorage.setItem('ms_demos', JSON.stringify(demos)); }, [demos]);
  useEffect(() => { localStorage.setItem('ms_testimonials', JSON.stringify(testimonials)); }, [testimonials]);
  // Keep sessionStorage in sync with currentUser state.
  // sessionStorage is tab-isolated — each tab has its own copy,
  // so copying a URL into a new tab always starts unauthenticated.
  useEffect(() => {
    if (currentUser) sessionStorage.setItem('ms_user', JSON.stringify(currentUser));
    else sessionStorage.removeItem('ms_user');
  }, [currentUser]);

  const showAlert = (title, message, type = 'success') => {
    setAlert({ title, message, type });
  };

  const login = (email, password) => {
    const user = users.find(u => u.email === email && u.password === password);
    if (user) { setCurrentUser(user); return true; }
    return false;
  };

  const signup = (name, email, password) => {
    if (users.find(u => u.email === email)) return false;
    const newUser = { id: Date.now(), name, email, password, role: 'Admin', image: null };
    setUsers(prev => [...prev, newUser]);
    setCurrentUser(newUser);
    return true;
  };

  const logout = () => {
    sessionStorage.removeItem('ms_active_page');
    setCurrentUser(null);
  };

  const updateUser = (data) => {
    const updated = { ...currentUser, ...data };
    setCurrentUser(updated);
    setUsers(prev => prev.map(u => u.id === updated.id ? updated : u));
  };

  const toggleTheme = () => setTheme(t => t === 'light' ? 'dark' : 'light');

  // Services
  const addService = (data) => {
    const now = new Date().toISOString();
    setServices(prev => [...prev, { id: Date.now(), ...data, createdAt: now, updatedAt: now }]);
  };
  const updateService = (id, data) => {
    setServices(prev => prev.map(s => s.id === id ? { ...s, ...data, updatedAt: new Date().toISOString() } : s));
  };
  const deleteService = (id) => {
    setServices(prev => prev.filter(s => s.id !== id));
  };

  // Enquiries
  const processEnquiry = (id) => {
    setEnquiries(prev => prev.map(e => e.id === id ? { ...e, status: 'completed' } : e));
  };

  // Demos
  const processDemo = (id) => {
    setDemos(prev => prev.map(d => d.id === id ? { ...d, status: 'completed' } : d));
  };

  // Testimonials
  const approveTestimonial = (id) => {
    setTestimonials(prev => prev.map(t => t.id === id ? { ...t, status: 'approved' } : t));
  };

  return (
    <AppContext.Provider value={{
      theme, toggleTheme, currentUser, login, signup, logout, updateUser,
      services, addService, updateService, deleteService,
      enquiries, processEnquiry,
      demos, processDemo,
      testimonials, approveTestimonial,
      alert, showAlert, closeAlert: () => setAlert(null),
      users
    }}>
      {children}
    </AppContext.Provider>
  );
}

export const useApp = () => useContext(AppContext);
